
import { CGroupTemplate } from '@ts/ui-models';

export const normalizeCGroupTemplateOptions = (entity: { oldEntity: CGroupTemplate; newEntity: CGroupTemplate }, attr: string, notify?: (message: string) => void, errory?: (value: boolean) => void): CGroupTemplate => {
  const { oldEntity, newEntity } = entity;
  if (!newEntity.ordered) {
    newEntity.rules = newEntity.rules.map((rule: any) => {
      delete rule.order;
      return rule;
    })
  }
  //We need to remove the prop data because the backend does not accept it, but we use that data to center the view when creating a new rule.
  const removeDataRecursive = (rules: any[] | any) => {
    rules.map(r => {
      delete r.data;
      if (r.rules) removeDataRecursive(r.rules)
    })
  }

  removeDataRecursive(newEntity.rules);

  return newEntity;
};
